import { Building2, MapPin, Trash2 } from 'lucide-react'
import React, { useState } from 'react'

import { useAreaActions, useAreaState } from '../stores/useAreaStore'

const PositionList: React.FC = () => {
  const { deleteArea } = useAreaActions()
  const [deletingAreaId, setDeletingAreaId] = useState<number | null>(null)
  const [confirmDeleteAreaId, setConfirmDeleteAreaId] = useState<number | null>(
    null
  )

  const { areas, selectedArea } = useAreaState()
  const { selectArea } = useAreaActions()

  const handleAreaSelect = (area: typeof selectedArea) => {
    selectArea(area)
  }

  const handleDeleteArea = async (areaId: number) => {
    setDeletingAreaId(areaId)
    await deleteArea(areaId)
    setConfirmDeleteAreaId(null)
    setDeletingAreaId(null)
  }

  const handleConfirmDelete = (areaId: number) => {
    setConfirmDeleteAreaId(areaId)
  }

  const handleCancelDelete = () => {
    setConfirmDeleteAreaId(null)
  }

  if (areas.length === 0) {
    return (
      <div className="text-center py-8">
        <Building2 className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">暂无库区</h3>
        <p className="mt-1 text-sm text-gray-500">点击上方按钮创建第一个库区</p>
      </div>
    )
  }

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
          库区列表
        </h3>

        {/* 全部库位选项 */}
        {/* <div
          onClick={() => handleAreaSelect(null)}
          className={`group flex items-start p-4 border rounded-lg mb-3 cursor-pointer transition-colors ${
            !selectedArea
              ? 'border-blue-500 bg-blue-50'
              : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
          }`}
        >
          <div className="flex items-start flex-1">
            <div
              className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg ${
                !selectedArea ? 'bg-blue-500' : 'bg-gray-400'
              }`}
            >
              <MapPin className="h-5 w-5 text-white" />
            </div>
            <div className="ml-4 flex-1">
              <h4
                className={`text-sm font-medium ${
                  !selectedArea ? 'text-blue-900' : 'text-gray-900'
                }`}
              >
                全部库位
              </h4>
              <p
                className={`text-sm mt-0.5 ${
                  !selectedArea ? 'text-blue-600' : 'text-gray-500'
                }`}
              >
                查看所有库区的库位
              </p>
            </div>
          </div>
        </div> */}

        {/* 库区列表 */}
        <div className="space-y-3">
          {areas.map((area) => (
            <div
              key={area.id}
              className={`group flex items-start p-4 border rounded-lg cursor-pointer transition-colors ${
                selectedArea?.id === area.id
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <div
                onClick={() => handleAreaSelect(area)}
                className="flex items-start flex-1"
              >
                <div
                  className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg ${
                    selectedArea?.id === area.id ? 'bg-blue-500' : 'bg-gray-400'
                  }`}
                >
                  <Building2 className="h-5 w-5 text-white" />
                </div>
                <div className="ml-4 flex-1">
                  {/* 标题行：库区名称和代码 */}
                  <div className="flex items-center justify-between mb-2">
                    <h4
                      className={`text-sm font-medium ${
                        selectedArea?.id === area.id
                          ? 'text-blue-900'
                          : 'text-gray-900'
                      }`}
                    >
                      {area.name}
                    </h4>
                  </div>

                  {/* 统计信息行 */}
                  <div className="flex items-center justify-between">
                    <div className="flex flex-col">
                      <span
                        className={`text-sm font-medium ${
                          selectedArea?.id === area.id
                            ? 'text-blue-700'
                            : 'text-gray-700'
                        }`}
                      >
                        总计 {area.positions.length || 0} 个库位
                      </span>
                    </div>
                  </div>

                  {/* 描述信息 */}
                  {area.description && (
                    <p
                      className={`text-xs mt-2 ${
                        selectedArea?.id === area.id
                          ? 'text-blue-600'
                          : 'text-gray-500'
                      }`}
                    >
                      {area.description}
                    </p>
                  )}
                </div>
              </div>

              {/* 删除按钮 */}
              <div className="ml-4 flex-shrink-0 pt-1">
                {confirmDeleteAreaId === area.id ? (
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleDeleteArea(area.id)}
                      disabled={deletingAreaId === area.id}
                      className="text-red-600 hover:text-red-800 text-xs font-medium disabled:opacity-50"
                    >
                      {deletingAreaId === area.id ? '删除中...' : '确认删除'}
                    </button>
                    <button
                      onClick={handleCancelDelete}
                      disabled={deletingAreaId === area.id}
                      className="text-gray-600 hover:text-gray-800 text-xs font-medium disabled:opacity-50"
                    >
                      取消
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => handleConfirmDelete(area.id)}
                    className="opacity-0 group-hover:opacity-100 text-gray-400 hover:text-red-600 transition-all"
                    title="删除库区"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PositionList
